// PABS custom SVG icon set

const DefaultIcon = ({ size = 24, strokeWidth = 3, children, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {children}
  </svg>
);

export const IconVelocity = (props) => (
  <DefaultIcon {...props}>
    <path d="M4 14C4 14 6 4 12 4C18 4 20 10 20 10" />
    <path d="M12 20L20 10" />
    <circle cx="8" cy="14" r="2" fill="currentColor" stroke="none" />
  </DefaultIcon>
);

export const IconCapacity = (props) => (
  <DefaultIcon {...props}>
    <path d="M4 16C4 16 7 20 12 20C17 20 20 16 20 16" />
    <path d="M4 10C4 10 7 14 12 14C17 14 20 10 20 10" />
    <path d="M4 4C4 4 7 8 12 8C17 8 20 4 20 4" />
    <circle cx="12" cy="14" r="1.5" fill="currentColor" stroke="none" />
  </DefaultIcon>
);

export const IconLeverage = (props) => (
  <DefaultIcon {...props}>
    <path d="M4 20H8C12 20 16 16 16 8V4" />
    <circle cx="16" cy="4" r="2" fill="currentColor" stroke="none" />
    <path d="M20 12V4" strokeOpacity="0.5" />
  </DefaultIcon>
);

export const IconRisk = (props) => (
  <DefaultIcon {...props}>
    <path d="M12 4C7 4 4 8 4 12C4 18 9 20 12 20C15 20 18 19 19 16" />
    <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
    <path d="M20 4L18 10" strokeLinecap="round" />
  </DefaultIcon>
);

export const IconOrchestration = (props) => (
  <DefaultIcon {...props}>
    <path d="M5 8C5 8 8 4 12 4C16 4 19 8 19 8" />
    <path d="M19 16C19 16 16 20 12 20C8 20 5 16 5 16" />
    <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
    <path d="M12 4V8" />
    <path d="M12 16V20" />
  </DefaultIcon>
);

export const IconStrategy = (props) => (
  <DefaultIcon {...props}>
    <path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4" />
    <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8" />
    <circle cx="8" cy="12" r="2" fill="currentColor" stroke="none" />
  </DefaultIcon>
);

export const IconContext = (props) => (
  <DefaultIcon {...props}>
    <path d="M4 6C4 6 8 12 12 12" />
    <path d="M20 6C20 6 16 12 12 12" />
    <path d="M12 12V20" />
    <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
  </DefaultIcon>
);

export const IconExecution = (props) => (
  <DefaultIcon {...props}>
    <path d="M12 4V14" />
    <path d="M12 14C12 14 14 20 20 20" />
    <path d="M12 14C12 14 10 20 4 20" />
    <circle cx="12" cy="4" r="2" fill="currentColor" stroke="none" />
  </DefaultIcon>
);

export const IconTension = (props) => (
  <DefaultIcon {...props}>
    <path d="M6 4C6 4 10 8 10 12C10 16 6 20 6 20" />
    <path d="M18 4C18 4 14 8 14 12C14 16 18 20 18 20" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
  </DefaultIcon>
);
